import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { isEmailVerifiedClaim } from "../../utils/auth";

/**
 * Intuit App Store / QBO "Apps" tab Launch URL.
 *
 * Intuit sends the user's browser here (no prior Wowzer session) when they
 * select "Launch" for this app. Per Intuit's SSO requirements, this page must
 * kick off Intuit Single Sign-on immediately -- known Intuit identities land
 * straight on the dashboard with no credential prompt.
 */
const IntuitLaunch = () => {
  const { loginWithRedirect, isAuthenticated, isLoading, user, getIdTokenClaims } = useAuth0();
  const navigate = useNavigate();
  const hasStarted = useRef(false);

  useEffect(() => {
    if (isLoading || hasStarted.current) return;
    hasStarted.current = true;

    if (isAuthenticated) {
      (async () => {
        const claims = await getIdTokenClaims().catch(() => null);
        if (isEmailVerifiedClaim(claims, user) === false) {
          navigate("/intuit-unverified", { replace: true });
          return;
        }
        navigate("/organizations", { replace: true });
      })();
      return;
    }

    loginWithRedirect({
      authorizationParams: {
        connection: "quickbooks-online",
        scope: "openid profile email",
      },
      appState: { returnTo: "/organizations" },
    }).catch((err) => {
      console.error("Intuit Launch SSO error:", err);
    });
  }, [isLoading, isAuthenticated, loginWithRedirect, navigate, user, getIdTokenClaims]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <Spin size="large" />
    </div>
  );
};

export default IntuitLaunch;
